import './styles.scss';
import React from 'react';
import TeamMemberCard from './TeamMemberCard';
import TeamCareerCard from './TeamCareerCard';
import TeamInfoCard from './TeamInfoCard';
import { useDispatch, useSelector } from 'react-redux';
import { selectEmployees, fetchEmployees, selectAboutUsPage } from 'store/slices/AboutUsSlice';
import ButtonShowMore from 'components/Button/ButtonShowMore';

const TeamsCards = () => {
    const [page, setPage] = React.useState(1);
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(
            // @ts-ignore
            fetchEmployees({ page }),
        );
    }, [dispatch, page]);

    const { team_show_more } = useSelector(selectAboutUsPage);
    const { data = [], next } = useSelector(selectEmployees);

    const handleShowMore = () => setPage(page + 1);

    return (
        <>
            <div className="team">
                {data.map((item, index) =>
                    item.type === 'info' ? (
                        <TeamInfoCard key={index} data={item} />
                    ) : (
                        <TeamMemberCard key={index} data={item} />
                    ),
                )}
                <TeamCareerCard />
            </div>
            {next && <ButtonShowMore text={team_show_more} onClick={handleShowMore} />}
        </>
    );
};

export default TeamsCards;
